/**
 * IMPORTS
 */

import { useMutation, useQueryClient } from "@tanstack/react-query";

// typings
import {
  ICreateVendaCreditosPayload,
  ICreateVendaCreditosResponse,
} from "@/hooks/vendas-creditos/criar-venda/index.d";

// store / zustand
import { useStoreZustandUserAuth } from "@/store-zustand/user-auth";

// domain / caso de usos
import { handleCriarVendaCreditos } from "@/domain/use-cases/vendas-creditos";
import { notifyAlert, notifyError, notifySuccess } from "@/utils/notify-messages";

export function useRealizarCompraCreditos() {
  const queryClient = useQueryClient(); // ← necessário para invalidar a query
  const { token } = useStoreZustandUserAuth();

  const mutation = useMutation<ICreateVendaCreditosResponse, Error, ICreateVendaCreditosPayload>({
    mutationFn: async (payload) => {
      return await handleCriarVendaCreditos(token!, payload);
    },
    onSuccess: async (data: any) => {
      if (data?.code !== 200) {
        notifyAlert(data.errors.message);
        return;
      }

      notifySuccess(data?.message ?? "Compra de créditos realizada com sucesso!");
      await queryClient.invalidateQueries({ queryKey: ["vendas-creditos"] });
      await queryClient.invalidateQueries({ queryKey: ["clientes"] });
    },
    onError: () => {
      notifyError("Houve um problema ao realizar compra de crédito para cliente!");
    },
  });

  return {
    criarVendaCreditos: mutation.mutate, // chamada direta
    criarVendaCreditosAsync: mutation.mutateAsync, // se quiser await
    isLoading: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
    data: mutation.data,
    isSuccess: mutation.isSuccess,
  };
}
